var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItalics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BCCCD9",
    d: "M12.841 16.2857H11.9343L13.5975 7.71429H14.6883C14.7878 7.71429 14.8841 7.67972 14.9608 7.6165C15.0376 7.55328 15.09 7.46535 15.109 7.36776L15.2762 6.51062C15.3278 6.246 15.1252 6 14.8555 6H10.577C10.4776 6 10.3812 6.03457 10.3045 6.09779C10.2277 6.16101 10.1754 6.24894 10.1563 6.34653L9.98914 7.20367C9.93752 7.46829 10.1402 7.71429 10.4098 7.71429H11.3164L9.65325 16.2857H8.59599C8.49657 16.2857 8.40024 16.3203 8.3235 16.3835C8.24676 16.4467 8.19439 16.5346 8.17534 16.6322L8.00807 17.4893C7.95645 17.754 8.15908 18 8.42874 18H12.6737C12.7731 18 12.8695 17.9654 12.9462 17.9022C13.0229 17.839 13.0753 17.7511 13.0944 17.6535L13.2616 16.7964C13.3132 16.5317 13.1106 16.2857 12.841 16.2857Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalics);
export default __webpack_public_path__ + "static/media/italics.d30660f98543c3b76d4e126f2bcc57d4.svg";
export { ForwardRef as ReactComponent };